setTimeout(() => {
    if (frappe.web_form_doc && frappe.web_form_doc.doc_type && frappe.web_form_doc.doc_type === 'Issue') {
        window.location.href = '/home/profile/tickets';
    }
}, 500);
